export default "__VITE_ASSET__C4YQP3wZ__"